import {Device} from 'twilio-client'

class PhoneOperator {
    constructor(twilio_token, twilio_options, phone_number = null) {
        this.phone_number = phone_number
        this.device = new Device
        this.device.setup(twilio_token, twilio_options)
        this.device.on('error', this.render_error_message)
        this.device.on('ready', this.handle_ready)
    }

    handle_ready(device) {
        this.device.connect ({"phone_number": this.phone_number})
    }

    render_error_message(error) {
        $("#twilio-errors .text-error").append(e.message)
        $("#twilio-errors").show()
    }
}

export default {PhoneOperator};
